import { useId } from "react";
import { Stack } from "../../Layout";
import { FormHelperText, FormLabel } from "../_partials";
import { TextFieldProps } from "../FormText/TextField";
import { Stepper } from "./Stepper";

export interface NumberStepperFieldProps
    extends Pick<TextFieldProps, "helperText" | "inputRef" | "label" | "name"> {
    editable?: boolean;
    isMaxDisabled?: boolean;
    isMinDisabled?: boolean;
    max?: number;
    min?: number;
    onChange: (value: number) => void;
    step?: number;
    value: number;
}

export function NumberStepperField({
    editable,
    helperText,
    inputRef,
    isMaxDisabled,
    isMinDisabled,
    label,
    max,
    min = 0,
    name,
    onChange,
    step,
    value,
}: NumberStepperFieldProps) {
    const id = useId();
    return (
        <Stack alignItems="center" direction="row" gap={2} justifyContent="space-between">
            <div>
                <FormLabel htmlFor={id}>{label}</FormLabel>
                {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
            </div>
            <Stepper
                editable={editable}
                id={id}
                inputRef={inputRef}
                isMaxDisabled={isMaxDisabled}
                isMinDisabled={isMinDisabled}
                label={label}
                max={max}
                min={min}
                name={name}
                onChange={onChange}
                step={step}
                value={value}
            />
        </Stack>
    );
}
